import conn from "@/store/utils/connection";
import resulter from "@/store/utils/resulter";
import api from "../apiEndPoint";

export default {
    toggleAktivitasShow: ({ commit }, payload) => {
        commit("toggleAktivitasShow", payload);
    },
    toggleStatus: ({ commit, dispatch }, payload) => {
        let posted = new FormData();

        Object.keys(payload).forEach(function(key) {
            posted.append(key, payload[key]);
        });

        commit("setFetching", true);
        commit("setResponse", {});

        conn.post(api.toggleStatus, posted, conn.contentType.form)
            .then((res) => {
                let { status, code, data, msg } = res.data;
                if (status && code === 200) {
                    dispatch("getDetailStatusTn", { iddevice: payload.iddevice, idStatus: payload.idschedule });
                } else {
                    commit("setFetching", false);
                }
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    getDetailStatus: ({ commit, dispatch }, { iddevice, idStatus }) => {
        let query = { iddevice, idschedule: idStatus };
        commit("setFetching", true);
        commit("setResponse", {});

        conn.get(api.getDetailStatus, query)
            .then((res) => {
                let { status, code, data, msg } = res.data;
                if (status && code === 200) {
                    dispatch("getDetailTinyDevice", { deviceId: iddevice });
                    commit("setStatusFull", data);
                    commit("setResponse", resulter.successResult(msg, data));
                } else {
                    commit("setFetching", false);
                }
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    getDetailStatusTn: ({ commit }, { iddevice, idStatus }) => {
        let query = { iddevice, idschedule: idStatus };
        commit("setFetching", true);
        commit("setResponse", {});

        conn.get(api.getDetailStatusTn, query)
            .then((res) => {
                let { status, code, data, msg } = res.data;
                if (status && code === 200) {
                    commit("setStatusTiny", data);
                    commit("setResponse", resulter.successResult(msg, data));
                }
                commit("setFetching", false);
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    getListAktivitas: ({ commit, getters }, { iddevice, idStatus }) => {
        let query = {
            iddevice,
            idschedule: idStatus,
            offset: getters.aktivitasPage.offset,
            limit: getters.aktivitasPage.limit,
        };

        commit("setFetching", true);
        commit("setResponse", {});
        conn.get(api.getListAktivitas, query)
            .then((res) => {
                let { status, code, data, msg } = res.data;
                if (status && code === 200) {
                    commit("setAktivitas", data);
                    commit("setAktivitasEnd", data.array[data.array.length - 1]);
                    commit("setNextAktivitasPage", data.array);
                    commit("setResponse", resulter.successResult(msg, data));
                }
                commit("setFetching", false);
                commit("setLoadMore", false);
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setLoadMore", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    updateStatus: ({ commit }, payload) => {
        let posted = new FormData();

        Object.keys(payload).forEach(function(key) {
            posted.append(key, payload[key]);
        });

        commit("setFetching", true);
        commit("resetPage", { target: "aktivitas" });
        commit("resetList", { target: "aktivitas" });
        commit("setResponse", {});

        return conn.post(api.updateStatus, posted, conn.contentType.form)
    },
    takeDownStory: ({ commit }, payload) => {
        let posted = new FormData();

        Object.keys(payload).forEach(function(key) {
            posted.append(key, payload[key]);
        });

        commit("setFetching", true);
        commit("setResponse", {});
        return conn.post(api.takeDownStory, posted, conn.contentType.form);
    },
    hapusStory: ({ commit }, payload) => {
        let posted = new FormData();

        Object.keys(payload).forEach(function(key) {
            posted.append(key, payload[key]);
        });

        commit("setFetching", true);
        commit("setResponse", {});
        return conn.post(api.toggleStatus, posted, conn.contentType.form);
    },
};
